import moment from "moment";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import 'moment/locale/tr';
import 'moment/locale/en-SG';

function SeoPages(props) {
  moment.updateLocale('tr', {
    meridiem: function (hour) {
      return hour < 12 ? 'ÖÖ' : 'ÖS'; // Custom translation for AM/PM indicators
    },
  });
  
  moment.locale(props?.language)
  
  const lang = localStorage.getItem("language");
  useEffect(() => {
    if (lang === null) {
      localStorage.setItem("language", props?.language);
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    // eslint-disable-next-line
  }, [props?.language]);

  useEffect(() => {
    document.title = props?.headerContent?.title;
    document.querySelector('meta[name="description"]').setAttribute("content", props?.headerContent?.description);
  }, [props?.headerContent]);
  return <></>;
}
const mapStateToProps = (state) => ({
  headerContent: state?.headerContent,
  language: state?.languageState?.language,
});
export default connect(mapStateToProps)(SeoPages);
